var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.board
        ? _c("share-board-modal", {
            ref: "shareboard",
            attrs: {
              state: _vm.state,
              modalId: "shareboard",
              board: _vm.board,
              sharedWith: _vm.getSharedInfoBoard(_vm.state, _vm.board).userIds
            },
            on: {
              addBoardShared: function($event) {
                return _vm.$emit("addBoardShared", $event)
              },
              removeBoardShared: function($event) {
                return _vm.$emit("removeBoardShared", $event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("activity-log-modal", {
        ref: "activityLog",
        attrs: { modalId: "activityLog", state: _vm.state },
        on: {
          logSelected: function($event) {
            return _vm.$emit("logSelected", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("responsible-modal", {
        ref: "responsibleMassselect",
        attrs: {
          modalId: "responsibleMassselect",
          state: _vm.state,
          responsibles: _vm.responsibles
        },
        on: {
          addResponsible: function($event) {
            return _vm.$emit("addResponsible", $event)
          },
          removeResponsible: function($event) {
            return _vm.$emit("removeResponsible", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("attribute-definitions-modal", {
        ref: "attributeDefinitionsModal",
        attrs: { state: _vm.state, board: _vm.board }
      }),
      _vm._v(" "),
      _c("lockdown-delay-modal", {
        ref: "lockdownDelayModal",
        attrs: { state: _vm.state, board: _vm.board },
        on: {
          save: function($event) {
            return _vm.$emit("save-lockdown-delay", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("board-create-modal", {
        ref: "boardCreateModal",
        attrs: { state: _vm.state },
        on: {
          "create-board": function($event) {
            return _vm.$emit("create-board", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("ApprovalRequestModal", {
        ref: "approvalRequest",
        attrs: { state: _vm.state }
      }),
      _vm._v(" "),
      _c("ApprovalListModal", {
        ref: "approvalList",
        attrs: { state: _vm.state },
        on: {
          openCard: function($event) {
            return _vm.openDetails(
              $event.board,
              $event.flow,
              $event.card,
              $event.readonly
            )
          }
        }
      }),
      _vm._v(" "),
      _c("MassSelectArchiveConfirmModal", {
        ref: "archiveMassselect",
        attrs: { state: _vm.state }
      }),
      _vm._v(" "),
      _c("MassSelectDeleteConfirmModal", {
        ref: "deleteMassselect",
        attrs: { state: _vm.state }
      }),
      _vm._v(" "),
      _c("MassSelectPdfConfirmModal", {
        ref: "pdfMassselect",
        attrs: { state: _vm.state }
      }),
      _vm._v(" "),
      _c("AssignedCardsModal", {
        ref: "assignedCards",
        attrs: { state: _vm.state },
        on: {
          openCard: function($event) {
            return _vm.openDetails(
              $event.board,
              $event.flow,
              $event.card,
              $event.readonly
            )
          }
        }
      }),
      _vm._v(" "),
      _vm.board && _vm.flow
        ? _c("port-modal", {
            ref: "portmodal",
            attrs: {
              modalId: "portModal",
              state: _vm.state,
              board: _vm.board,
              flow: _vm.flow
            },
            on: {
              reload: function($event) {
                return _vm.$emit("reload")
              },
              close: _vm.onPortClose
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.board && _vm.flow && _vm.card
        ? _c("details-modal", {
            ref: "detailsmodal",
            attrs: {
              modalId: "details",
              state: _vm.state,
              board: _vm.board,
              flow: _vm.flow,
              card: _vm.card,
              readonly: _vm.readonlyDetails
            },
            on: {
              close: _vm.closeDetails,
              reload: function($event) {
                return _vm.$emit("reload")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }